/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CodeLanguage } from './CodeLanguage';
import {
    CodeLanguageFromJSON,
    CodeLanguageFromJSONTyped,
    CodeLanguageToJSON,
    CodeLanguageToJSONTyped,
} from './CodeLanguage';
import type { ProblemType } from './ProblemType';
import {
    ProblemTypeFromJSON,
    ProblemTypeFromJSONTyped,
    ProblemTypeToJSON,
    ProblemTypeToJSONTyped,
} from './ProblemType';

/**
 * 
 * @export
 * @interface ProblemUpdate
 */
export interface ProblemUpdate {
    /**
     * 
     * @type {string}
     * @memberof ProblemUpdate
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemUpdate
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ProblemUpdate
     */
    ordinal?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemUpdate
     */
    statement: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemUpdate
     */
    solution_code: string;
    /**
     * 
     * @type {string}
     * @memberof ProblemUpdate
     */
    extra_code?: string;
    /**
     * 
     * @type {number}
     * @memberof ProblemUpdate
     */
    points: number;
    /**
     * 
     * @type {number}
     * @memberof ProblemUpdate
     */
    time_limit?: number;
    /**
     * 
     * @type {number}
     * @memberof ProblemUpdate
     */
    complexity?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProblemUpdate
     */
    is_public?: boolean;
    /**
     * 
     * @type {ProblemType}
     * @memberof ProblemUpdate
     */
    problem_type: ProblemType;
    /**
     * 
     * @type {CodeLanguage}
     * @memberof ProblemUpdate
     */
    solution_language: CodeLanguage;
}



/**
 * Check if a given object implements the ProblemUpdate interface.
 */
export function instanceOfProblemUpdate(value: object): value is ProblemUpdate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('statement' in value) || value['statement'] === undefined) return false;
    if (!('solution_code' in value) || value['solution_code'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('problem_type' in value) || value['problem_type'] === undefined) return false;
    if (!('solution_language' in value) || value['solution_language'] === undefined) return false;
    return true;
}

export function ProblemUpdateFromJSON(json: any): ProblemUpdate {
    return ProblemUpdateFromJSONTyped(json, false);
}

export function ProblemUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProblemUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'ordinal': json['ordinal'] == null ? undefined : json['ordinal'],
        'statement': json['statement'],
        'solution_code': json['solution_code'],
        'extra_code': json['extra_code'] == null ? undefined : json['extra_code'],
        'points': json['points'],
        'time_limit': json['time_limit'] == null ? undefined : json['time_limit'],
        'complexity': json['complexity'] == null ? undefined : json['complexity'],
        'is_public': json['is_public'] == null ? undefined : json['is_public'],
        'problem_type': ProblemTypeFromJSON(json['problem_type']),
        'solution_language': CodeLanguageFromJSON(json['solution_language']),
    };
}

export function ProblemUpdateToJSON(json: any): ProblemUpdate {
    return ProblemUpdateToJSONTyped(json, false);
}

export function ProblemUpdateToJSONTyped(value?: ProblemUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'ordinal': value['ordinal'],
        'statement': value['statement'],
        'solution_code': value['solution_code'],
        'extra_code': value['extra_code'],
        'points': value['points'],
        'time_limit': value['time_limit'],
        'complexity': value['complexity'],
        'is_public': value['is_public'],
        'problem_type': ProblemTypeToJSON(value['problem_type']),
        'solution_language': CodeLanguageToJSON(value['solution_language']),
    };
}

